<template>
  <button
    :class="(isDisabled ? 'bg-gray-600 text-white shadow-gray cursor-default' : typeShadow+' '+textColor+' '+bgColor+' '+borderColor) + ' h-16 px-5 xl:px-6 2xl:px-4 flex items-center min-w-max-content w-max min-w-max group border '+padding+' leading-4 rounded-md focus:outline-none transition ease-in-out duration-300 transform hover:scale-110'"
    :disabled="isDisabled"
  >
    <div
      v-if="!right && icon != null"
      :class="(isDisabled ? 'text-white bg-gray-600' : iconColor+' '+bgColorSquare) + ' inline-flex p-1.5 sm:w-auto leading-4 border border-transparent rounded-md transition ease-in-out duration-150'"
    >
      <span
        v-if="spinner"
        class="xl:h-3 xl:w-3 xxl:h-4 xxl:w-4 2xl:h-5 2xl:w-5 spinner"
      />
      <icon
        v-else
        :name="icon"
        class="xl:h-3 xl:w-3 xxl:h-4 xxl:w-4 2xl:h-5 2xl:w-5"
      />
    </div>
    <p
      class="w-full text-center mx-2"
      :class="{'hidden xl:block':icon && resp}"
    >
      <span :class="sizeText">{{ libelle }}</span>
    </p>
    <div
      v-if="right && (icon != null || spinner)"
      :class="(isDisabled ? 'text-white bg-gray-600' : iconColor+' '+bgColorSquare) + ' relative inline-flex px-2 py-2 sm:w-auto leading-4 border border-transparent rounded-md transition ease-in-out duration-300 hover:scale-110'"
    >
      <span
        v-if="spinner"
        class="h-3 w-3 xxl:h-4 xxl:w-4 2xl:h-5 2xl:w-5 spinner"
      />
      <icon
        v-else
        :name="icon"
        class="h-3 w-3 xxl:h-4 xxl:w-4 2xl:h-5 2xl:w-5"
      />
    </div>
  </button>
</template>

<script>

import Icon from './Icon';

export default {
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    borderColor: String,
    textColor: String,
    bgColor: String,
    iconColor: String,
    bgColorSquare: String,
    libelle: String,
    icon: String,
    right: Boolean,
    spinner: Boolean,
    responsive: Boolean,
    typeShadow: String,
    textSize: String
  },
  components:{
    Icon,
  },
  data(){
    return{
      resp: false,
      padding: 'p-0.5',
      sizeText: 'text-base'
    };
  },
  mounted(){
    // minimize when smaller screen ?
    if(this.responsive){
      this.resp = true;
    }

    //In case there isn't icon
    if(!this.icon || this.icon == null || this.icon == undefined || this.icon == ''){
      this.padding = 'px-2 py-3';
    }

    if(this.textSize && this.textSize != null && this.textSize != undefined && this.textSize != ''){
      this.sizeText = this.textSize;
    }

  }
};
</script>
